import { render, staticRenderFns } from "./shopCart.vue?vue&type=template&id=8b823e4c&scoped=true&"
import script from "./shopCart.vue?vue&type=script&lang=js&"
export * from "./shopCart.vue?vue&type=script&lang=js&"
import style0 from "./shopCart.vue?vue&type=style&index=0&id=8b823e4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b823e4c",
  null
  
)

export default component.exports